export let ClickableElement;

(function (ClickableElement) {
  ClickableElement["AddItemToBundle"] = "add_item_to_bundle";
  ClickableElement["BrowseCatalog"] = "browse_catalog";
  ClickableElement["CancelBundle"] = "cancel_bundle";
  ClickableElement["CancelInstallAppBanner"] = "cancel_install_app_banner";
  ClickableElement["ChangeEmail"] = "change_email";
  ClickableElement["ClosePage"] = "close_page";
  ClickableElement["CloseScreen"] = "close_screen";
  ClickableElement["ConfirmEverythingIsOk"] = "confirm_everything_is_ok";
  ClickableElement["ConfirmOrderReturn"] = "confirm_order_return";
  ClickableElement["StartBundle"] = "start_bundle";
  ClickableElement["CreateBundle"] = "create_bundle";
  ClickableElement["CreateCollection"] = "create_collection";
  ClickableElement["DeleteCollection"] = "delete_collection";
  ClickableElement["EditCollection"] = "edit_collection";
  ClickableElement["EditPhoto"] = "edit_photo";
  ClickableElement["Help"] = "help";
  ClickableElement["IconsExplanation"] = "icons_explanation";
  ClickableElement["IHaveAnIssue"] = "i_have_an_issue";
  ClickableElement["InstallAppBanner"] = "install_app_banner";
  ClickableElement["MarkAsReceived"] = "mark_as_received";
  ClickableElement["NeverShowTranslationBanner"] = "never_show_translation_banner";
  ClickableElement["NpsSurveyDismiss"] = "nps_survey_dismiss";
  ClickableElement["NpsSurveySend"] = "nps_survey_send";
  ClickableElement["OpenTrackingPage"] = "open_tracking_page";
  ClickableElement["PersonalizationButtonAfterFeed"] = "personalization_button_after_feed";
  ClickableElement["PushUpItem"] = "push_up_item";
  ClickableElement["PromoteCloset"] = "promote_closet";
  ClickableElement["RecentSearchOpen"] = "recent_search_open";
  ClickableElement["RemoveItemFromBundle"] = "remove_item_from_bundle";
  ClickableElement["RemoveSearch"] = "remove_search";
  ClickableElement["RequestReturn"] = "request_to_return";
  ClickableElement["ResolveComplaint"] = "confirm_resolve_this_issue";
  ClickableElement["SaveSearch"] = "save_search";
  ClickableElement["SavedSearchOpen"] = "saved_search_open";
  ClickableElement["SearchBar"] = "search_bar";
  ClickableElement["SearchBarType"] = "search_bar_type";
  ClickableElement["SeeWholeClosetCta"] = "see_whole_closet_cta";
  ClickableElement["ShowItemPerformance"] = "show_item_performance";
  ClickableElement["SubmitRearrange"] = "submit_rearrange";
  ClickableElement["SubmitKybForm"] = "submit_kyb";
  ClickableElement["TrackingInformationLink"] = "tracking_information_link";
  ClickableElement["TrackParcel"] = "track_parcel";
  ClickableElement["TrackReturnParcel"] = "track_return_parcel";
  ClickableElement["TrackShipmentView"] = "track_shipment_view";
  ClickableElement["TranslateDescription"] = "translate_description";
  ClickableElement["TranslateFeedback"] = "translate_feedback";
  ClickableElement["TranslateMessage"] = "translate_message";
  ClickableElement["UploadItem"] = "upload_item";
  ClickableElement["UploadMoreAccept"] = "upload_more_accept";
  ClickableElement["UploadMoreCancel"] = "upload_more_cancel";
  ClickableElement["UploadPackageSelect"] = "upload_package_select";
  ClickableElement["ViewMorePromotedUsers"] = "view_more_promoted_users";
  ClickableElement["ViewComplaint"] = "view_complaint";
  ClickableElement["ViewDeliveryInstructions"] = "view_delivery_instructions";
  ClickableElement["ViewIssueDetails"] = "view_issue_details";
  ClickableElement["DownloadShippingLabel"] = "download_shipping_label";
  ClickableElement["CheckoutPayButton"] = "pay";
  ClickableElement["AddNewCardButton"] = "add_new_card";
  ClickableElement["AddNewCardFromPaymentOptions"] = "add_new_card_from_payment_options";
  ClickableElement["ConfirmComplaintResolved"] = "confirm_complaint_resolved";
  ClickableElement["RefuseComplaintResolved"] = "refuse_complaint_resolved";
  ClickableElement["PopularItemsButton"] = "all_popular_items_button";
  ClickableElement["PopularItemsBlock"] = "all_popular_items_block";
  ClickableElement["CancelLeavingModal"] = "cancel_leaving_modal";
  ClickableElement["ShowLeavingModal"] = "show_leaving_modal";
  ClickableElement["ProceedFromLeavingModal"] = "proceed_from_leaving_modal";
  ClickableElement["Favourite"] = "favorite";
  ClickableElement["LearnMore"] = "learn_more";
  ClickableElement["KycSaveAddress"] = "save_address";
  ClickableElement["KycContinueWithSelectedDocument"] = "continue_with_selected_document";
  ClickableElement["KycContinueWithSelectedSupportingDocument"] = "continue_with_selected_supporting_document";
  ClickableElement["KycUploadPhotoDone"] = "upload_photo_done";
  ClickableElement["KycDeleteDocument"] = "delete_document";
  ClickableElement["KycSubmitIdentityConfirmation"] = "submit_identity_confirmation";
  ClickableElement["KycDiscardChanges"] = "discard_changes";
  ClickableElement["KycTryAgain"] = "try_again";
  ClickableElement["KycContactSupport"] = "contact_support";
  ClickableElement["KycConfirmIdentity"] = "confirm_identity";
  ClickableElement["GetShippingLabel"] = "get_shipping_label";
  ClickableElement["Confirm"] = "confirm";
  ClickableElement["Notification"] = "notification";
  ClickableElement["DonationsSetup"] = "set_up_donations";
  ClickableElement["FundraiserSetup"] = "set_up_donations";
  ClickableElement["DonationsStart"] = "start_donations";
  ClickableElement["FundraiserStart"] = "start_donations";
  ClickableElement["DonationsManage"] = "manage_donations";
  ClickableElement["FundraiserManage"] = "manage_donations";
  ClickableElement["DonationsUpdate"] = "save_donations_changes";
  ClickableElement["FundraiserUpdate"] = "save_donations_changes";
  ClickableElement["DonationsStop"] = "stop_donations";
  ClickableElement["FundraiserStop"] = "stop_donations";
  ClickableElement["DonationsLearnMore"] = "learn_about_donations_from_donations_overview";
  ClickableElement["FundraiserLearnMore"] = "learn_about_donations_from_donations_overview";
  ClickableElement["DonationsAboutUserProfile"] = "learn_about_donations_from_wardrobe";
  ClickableElement["DonationsAboutUserInfo"] = "learn_about_donations_from_user_about_section";
  ClickableElement["RecentlyFavouritedItemsButton"] = "all_recently_favorited_items_button";
  ClickableElement["RecentlyFavouritedItemsBlock"] = "all_recently_favorited_items_block";
  ClickableElement["Hyperlink"] = "hyperlink";
  ClickableElement["DropOffPointsLink"] = "drop_off_points_link";
  ClickableElement["MergeFavoriteItemListBanner"] = "merge_favorite_item_list_banner";
  ClickableElement["MergeCatalogBanner"] = "merge_catalog_banner";
  ClickableElement["MergeReviewsBanner"] = "merge_reviews_banner";
  ClickableElement["MergeBalanceBanner"] = "merge_balance_banner";
  ClickableElement["MergeFollowersBanner"] = "merge_followers_banner";
  ClickableElement["MergeFollowingBanner"] = "merge_following_banner";
  ClickableElement["MergeAnnouncementAction"] = "merge_announcement_cta";
  ClickableElement["MergeAnnouncementLink"] = "merge_announcement_link";
  ClickableElement["MergeSelectFaq"] = "merge_select_faq";
  ClickableElement["RecommendedItemListBanner"] = "recommended_item_list_banner";
  ClickableElement["ItemsBasedOnRecentPurchasesButton"] = "all_items_based_on_recent_purchases_button";
  ClickableElement["ItemsBasedOnRecentPurchasesBlock"] = "all_items_based_on_recent_purchases_block";
  ClickableElement["SearchThisArea"] = "search_this_area";
  ClickableElement["CloseListerActivationBanner"] = "close_lister_activation_banner";
  ClickableElement["UploadAfterListerActivationBanner"] = "upload_after_lister_activation_banner";
  ClickableElement["SaveBillingAddress"] = "save_address";
  ClickableElement["GoToMyBalance"] = "go_to_my_balance";
  ClickableElement["SelectDropoffType"] = "select_dropoff_type";
  ClickableElement["SubmitPaymentMethod"] = "submit_payment_method";
  ClickableElement["WebPhotosLearnMore"] = "web_photos_learn_more";
  ClickableElement["WebPhotosCloseModal"] = "web_photos_ok_close_modal";
  ClickableElement["LoginWithFacebook"] = "login_with_facebook";
  ClickableElement["LoginWithGoogle"] = "login_with_google";
  ClickableElement["LoginWithApple"] = "login_with_apple";
  ClickableElement["Login"] = "login";
  ClickableElement["UseThisCard"] = "use_this_card";
  ClickableElement["SaveTheCard"] = "save_the_card";
  ClickableElement["DontSaveTheCard"] = "dont_save_the_card";
  ClickableElement["CopyTrackingNumber"] = "copy_tracking_number";
  ClickableElement["SaveAddress"] = "save_address";
  ClickableElement["AddPhoto"] = "add_photo";
  ClickableElement["Submit"] = "submit";
  ClickableElement["ServiceFeeInfo"] = "service_fee_info";
  ClickableElement["ShippingMethodSelection"] = "shipping_method_selection";
  ClickableElement["ShippingMethodEducation"] = "shipping_method_education";
  ClickableElement["SelectShippingMethod"] = "select_shipping_method";
  ClickableElement["ChooseParcelSize"] = "choose_parcel_size";
  ClickableElement["SelectParcelSize"] = "select_parcel_size";
  ClickableElement["BusinessRegistrationBack"] = "business_registration_back";
  ClickableElement["CompleteRegistration"] = "complete_registration";
  ClickableElement["ConvertToBusiness"] = "convert_to_business";
  ClickableElement["OpenDigitalLabel"] = "open_digital_label";
  ClickableElement["DownloadDigitalLabel"] = "download_digital_label";
  ClickableElement["DownloadIosApp"] = "download_ios_app";
  ClickableElement["DownloadAndroidApp"] = "download_android_app";
  ClickableElement["DiscardChanges"] = "discard_changes";
  ClickableElement["PricingDetails"] = "pricing_details";
  ClickableElement["ContactDetailsContinue"] = "contact_details_continue";
  ClickableElement["ContactDetailsDelete"] = "delete_contact_details";
  ClickableElement["ContactDetailsDeleteConfirm"] = "confirm_phone_number_deletion";
  ClickableElement["MuteVideo"] = "mute_video";
  ClickableElement["UnmuteVideo"] = "unmute_video";
  ClickableElement["MergeMessageListBanner"] = "merge_message_list_banner";
  ClickableElement["SellerAddContactDetails"] = "seller_add_contact_details";
  ClickableElement["SavePhoneNumber"] = "save_phone_number";
  ClickableElement["MergeMissingInfoContinue"] = "merge_missing_info_continue";
  ClickableElement["ZipCodeForTaxInfoBanner"] = "zip_code_for_tax_info_banner";
  ClickableElement["CrmMessageLink"] = "crm_message_link";
  ClickableElement["FeedLoadMoreButton"] = "feed_load_more_button";
  ClickableElement["CrmInAppMessageDismiss"] = "crm_in_app_message_dismiss";
  ClickableElement["SalesTaxInfo"] = "sales_tax_info";
  ClickableElement["BundlesPolicyLink"] = "bundles_policy_help_centre_link";
  ClickableElement["Skip"] = "skip";
  ClickableElement["Save"] = "save";
  ClickableElement["Ok"] = "ok";
  ClickableElement["ImpressionsTab"] = "impressions_tab";
  ClickableElement["ProfileVisitsTab"] = "profile_visits_tab";
  ClickableElement["ItemVisitsTab"] = "item_visits_tab";
  ClickableElement["InsightsHelp"] = "discovery_help";
  ClickableElement["ActionsHelp"] = "actions_help";
  ClickableElement["FreeReturnLabelLearnMore"] = "free_return_label_learn_more";
  ClickableElement["ReviewClosetPromotionOrder"] = "review_closet_promo_order";
  ClickableElement["ConfirmClosetPromotionOrder"] = "pay_closet_promo_order";
  ClickableElement["ClosetPromotionPreCheckoutHelp"] = "how_its_working";
  ClickableElement["ClosetPromotionReviewHelp"] = "how_it_works";
  ClickableElement["CatalogTab"] = "catalog_tab";
  ClickableElement["RefundPolicyLink"] = "refund_policy_link";
  ClickableElement["PushUpBundle"] = "push_up_bundle";
  ClickableElement["MarkTransactionAsShipped"] = "mark_transaction_as_shipped";
  ClickableElement["SelectLabelType"] = "select_label_type";
  ClickableElement["ConfirmMarkTransactionAsShipped"] = "confirm_mark_transaction_as_shipped";
  ClickableElement["ReviewPushupOrder"] = "review_push_up_order";
  ClickableElement["MultiplePushUp"] = "multiple_push_up";
  ClickableElement["PushUpDurationChange"] = "push_up_duration_change";
  ClickableElement["Cancel"] = "cancel";
  ClickableElement["ConfirmDirectDonationOrder"] = "pay_direct_donation_order";
  ClickableElement["ConfirmItemPushUp"] = "confirm_item_push_up";
  ClickableElement["ConfirmMultipleItemsPushUp"] = "confirm_multiple_items_push_up";
  ClickableElement["MakeBuyerSideOffer"] = "make_buyer_side_offer";
  ClickableElement["SelectSuggestedOfferDiscount"] = "select_suggested_discount";
  ClickableElement["PushUpLearnMode"] = "push_up_learn_more";
  ClickableElement["Logo"] = "logo";
  ClickableElement["Done"] = "done";
  ClickableElement["SellingTips"] = "improvement_tips";
  ClickableElement["PhotoTips"] = "photo_tips";
  ClickableElement["PriceTips"] = "price_tips";
  ClickableElement["DescriptionTips"] = "description_tips";
  ClickableElement["UpdateItem"] = "update_listing";
  ClickableElement["InteractionRate"] = "engagement_metric";
  ClickableElement["ReturnOrder"] = "return_order";
  ClickableElement["GiveFeedback"] = "give_feedback";
  ClickableElement["SubmitSuccess"] = "submit_success";
  ClickableElement["ConfirmSubmit"] = "confirm_submit";
  ClickableElement["ApplyFilters"] = "apply_filters";
  ClickableElement["ClearFilters"] = "clear_filters";
  ClickableElement["CancelFilters"] = "cancel_filters";
  ClickableElement["Drag"] = "drag";
  ClickableElement["ReuploadItem"] = "reupload_item";
  ClickableElement["PickPackageSize"] = "pick_package_size";
  ClickableElement["SubmitPackageSize"] = "submit_package_size";
  ClickableElement["SelectFilters"] = "select_filters";
  ClickableElement["SustainabilityPageLink"] = "sustainability_page_link";
  ClickableElement["EnterDonationsFromWebMenu"] = "enter_donations_from_web_menu";
  ClickableElement["EnterDonationFromSettings"] = "enter_donations_from_settings";
  ClickableElement["NavigationMenuToggle"] = "navigation_menu_toggle";
  ClickableElement["CatalogSearchResultsRanking"] = "catalog_search_results_ranking";
  ClickableElement["SessionsChangePassword"] = "sessions_change_password";
  ClickableElement["SessionsLogOut"] = "sessions_log_out";
  ClickableElement["ClosetPromotionHelp"] = "spotlight_information";
  ClickableElement["HelpCenterSearchResult"] = "help_center_search_result";
  ClickableElement["Verify"] = "verify";
  ClickableElement["DidntReceiveEmail"] = "didnt_receive_email";
  ClickableElement["PayWithBlikCode"] = "pay_with_blik_code";
  ClickableElement["Start"] = "start";
  ClickableElement["SeeWholeFeaturedCollectionCta"] = "see_whole_fc_cta";
  ClickableElement["OfflineVerificationCheckbox"] = "check_authenticity";
  ClickableElement["OfflineVerificationLearnMoreLink"] = "how_authenticity_works";
  ClickableElement["OfflineVerificationTrackedShippingLearnMoreLink"] = "authenticity_tracked_shipping_learn_more";
  ClickableElement["FilterSold"] = "filter_sold";
  ClickableElement["FilterDrafts"] = "filter_drafts";
  ClickableElement["FilterHidden"] = "filter_hidden";
  ClickableElement["FilterReserved"] = "filter_reserved";
  ClickableElement["FilterActive"] = "filter_active";
  ClickableElement["PhysicalAuthenticityBuyer"] = "physical_auth_buyer";
  ClickableElement["PhysicalAuthenticitySeller"] = "physical_auth_seller";
  ClickableElement["OfflineVerificationHowItWorks"] = "physical_auth_how_it_works";
  ClickableElement["OfflineVerificationLearnMore"] = "physical_auth_learn_more";
  ClickableElement["OfflineVerificationGotIt"] = "physical_auth_got_it";
  ClickableElement["ShippingDiscountDetails"] = "shipping_discount_details";
  ClickableElement["ManageItems"] = "manage_items";
  ClickableElement["SaveOrdering"] = "save_ordering";
  ClickableElement["VasGalleryHelp"] = "vas_gallery_help";
  ClickableElement["VasGalleryItem"] = "vas_gallery_item";
  ClickableElement["VasGalleryConfirmOrder"] = "confirm_vas_gallery_order";
  ClickableElement["PromoteItem"] = "promote_item";
  ClickableElement["Close"] = "close";
  ClickableElement["MultipleVasGallery"] = "multiple_vas_gallery";
  ClickableElement["ConfirmContactUs"] = "confirm_contact_us";
  ClickableElement["MessageReply"] = "message_reply";
  ClickableElement["SkipTerms"] = "skip_terms";
  ClickableElement["AcceptTerms"] = "accept_terms";
  ClickableElement["RedirectTerms"] = "redirect_terms";
  ClickableElement["SeeCompensationInformation"] = "see_compensation_information";
  ClickableElement["SeeDropoffPointsInformation"] = "see_dropoff_points_information";
  ClickableElement["CarrierPreferencesToggle"] = "carrier_preferences_toggle";
  ClickableElement["CloseCarrierDisableModal"] = "close_carrier_disable_modal";
  ClickableElement["SatisfactionSurveySend"] = "satisfaction_survey_send";
  ClickableElement["PromoteFeaturedCollection"] = "promote_featured_collection";
  ClickableElement["ActivateFeaturedCollection"] = "activate_featured_collection";
  ClickableElement["ReviewCollection"] = "review_collection";
  ClickableElement["AddItems"] = "add_items";
  ClickableElement["ProceedToCheckout"] = "proceed_to_checkout";
  ClickableElement["SaveCollection"] = "save_collection";
  ClickableElement["UpdateCollection"] = "update_collection";
  ClickableElement["PayFeaturedCollection"] = "pay_featured_collection";
  ClickableElement["ApplyChanges"] = "apply_changes";
  ClickableElement["AskSellerButton"] = "write_message";
  ClickableElement["CloseAd"] = "close_ad";
  ClickableElement["ClosetPromotionDynamicPricingInfo"] = "dynamic_pricing_info";
  ClickableElement["EditItem"] = "edit_item";
  ClickableElement["DeleteItem"] = "delete_item";
  ClickableElement["HideItem"] = "hide_item";
  ClickableElement["ExtraServicePendingPaymentTryAgain"] = "try_again_payment_still_pending_modal";
  ClickableElement["CarrierTermsAndConditions"] = "carrier_terms_and_conditions";
  ClickableElement["FeedbackAllReviewsFilter"] = "all_reviews";
  ClickableElement["FeedbackMemberReviewsFilter"] = "member_reviews";
  ClickableElement["FeedbackAutoReviewsFilter"] = "automatic_reviews";
  ClickableElement["ProcessingListingStatusInfo"] = "processing_status_info_button";
  ClickableElement["ProcessingListingStatusModalFaqLink"] = "processing_status_modal_faq_link";
  ClickableElement["CtaPromptContinue"] = "cta_prompt_continue";
  ClickableElement["CtaPromptImageContinue"] = "cta_prompt_image_continue";
  ClickableElement["WalletBalanceInfo"] = "wallet_balance_info";
  ClickableElement["PushUpLearnMore"] = "push_up_learn_more";
  ClickableElement["FollowedUserSeeAllItems"] = "followed_user_see_all_items";
  ClickableElement["FeedbackTab"] = "feedback_tab";
  ClickableElement["ProfileTab"] = "profile_tab";
  ClickableElement["AboutTab"] = "about_tab";
  ClickableElement["Followers"] = "followers";
  ClickableElement["Following"] = "following";
  ClickableElement["AskSeller"] = "ask_seller";
  ClickableElement["PhotosMetadataNote"] = "photos_metadata_note";
  ClickableElement["VasInfo"] = "vas_info";
  ClickableElement["AddressSearchBar"] = "address_search_bar";
  ClickableElement["DropOffPointsMapLink"] = "drop_off_points_map_link";
  ClickableElement["DropOffPointDetails"] = "drop_off_point_details";
  ClickableElement["TaxpayersCheckTaxRules"] = "taxpayers_check_tax_rules";
  ClickableElement["PriceInformation"] = "price_information";
  ClickableElement["SeeDropOffPoints"] = "see_drop_off_points";
  ClickableElement["TaxRuleItem"] = "tax_rule_item";
  ClickableElement["AddCollection"] = "add_collection";
  ClickableElement["ActivateFeaturedCollections"] = "activate_featured_collections";
  ClickableElement["ManageCollections"] = "manage_collections";
  ClickableElement["TaxpayersDac7Banner"] = "taxpayers_dac7_banner";
  ClickableElement["CtaRedirect"] = "cta_redirect";
  ClickableElement["DropOffPoint"] = "drop_off_point";
  ClickableElement["CvvFieldInfo"] = "cvv_field_info";
  ClickableElement["DragCollection"] = "drag_collection";
  ClickableElement["ShippingServiceType"] = "shipping_service_type";
})(ClickableElement || (ClickableElement = {}));